module.exports = __webpack_public_path__ + "media/components/products/Horizontal_GREEN-36e10cdc78037776a73f71de79450926.svg";